<template>
  <div
    v-if="isLoading && !forceHideLoader"
    id="loader-spinner-container"
  >
    <v-progress-circular
      v-if="isLoading && !forceHideLoader"
      id="loader-progress-spinner"
      size="100"
      width="10"
      units="px"
      indeterminate
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "ProgressSpinner",
  props: {
    isLoading: Number,
    forceHideLoader: Boolean,
  },
});
</script>

<style>
#loader-progress-spinner {
  width: 100%;
  margin: auto;
  position: fixed;
  z-index: 9999;
}

#loader-spinner-container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
</style>
